import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const NailSalon = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my nail salon business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps nail salon businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for nail salon businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most nail salon businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my nail salon business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like nail salon. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Nail Salon - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Nail Salon CRM", url: "/industries/nail-salon" }
  ];

  const industryData = {
    name: 'Nail Salon',
    title: 'Fill Every Chair & Turn Clients into Weekly Regulars',
    subtitle: 'Automate rebooking, reduce no-shows, and build a base of loyal recurring clients',
    icon: '💅',
    challenges: [
      'Last-minute cancellations',
      'Hard to get clients to rebook',
      'Chairs sit empty during slow hours',
      'One-time clients never return',
      'Phone constantly rings during services'
    ],
    solutions: [
      'Online booking 24/7',
      'Automatic rebook reminders',
      'Cancellation waitlist automation',
      'Loyalty program tracking',
      'Off-peak discount automation'
    ],
    features: [
      'Client CRM with service history',
      'Online booking system',
      'Automatic rebook campaigns',
      'Cancellation waitlist',
      'Loyalty rewards tracking',
      'Photo galleries',
      'Package management',
      'Review automation'
    ],
    results: [
      '75% become weekly regulars',
      'Fill 95% of available slots',
      '50% reduction in no-shows',
      '£4.1K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Nail Salon UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for nail salon businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for nail salon UK, nail salon business software, nail salon customer management, nail salon lead generation UK"
        url="/industries/nail-salon"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default NailSalon;